module.exports = __webpack_public_path__ + "img/img_search.c10ff583.svg";